const prefix = 'WALLET_';

export const ClientWalletActionTypes = {
  GET_CLIENT_WALLET_LIST: `${prefix}GET_CLIENT_WALLET_LIST`,
  SET_CLIENT_WALLET_LIST: `${prefix}SET_CLIENT_WALLET_LIST`,
  SET_CLIENT_WALLET_CHARGE: `${prefix}SET_CLIENT_WALLET_CHARGE`,
  SET_CLIENT_WALLET_INITIAL_CHARGE: `${prefix}SET_CLIENT_WALLET_INITIAL_CHARGE`,
  GET_CLIENT_EXTENDED_WALLET_LIST: `${prefix}GET_CLIENT_EXTENDED_WALLET_LIST`,
  SET_CLIENT_WALLET_INITIAL: `${prefix}SET_CLIENT_WALLET_INITIAL`,
};

const getClientWalletList = () => ({ type: ClientWalletActionTypes.GET_CLIENT_WALLET_LIST });
const setClientWalletCharge = (data: { walletChargeCredit: string }) => ({ type: ClientWalletActionTypes.SET_CLIENT_WALLET_CHARGE, data: data });
const getExtendedClientWalletList = () => ({ type: ClientWalletActionTypes.GET_CLIENT_EXTENDED_WALLET_LIST });
const setClientWalletInitial = () => ({ type: ClientWalletActionTypes.SET_CLIENT_WALLET_INITIAL });

export const ClientWalletActions = {
  getClientWalletList: getClientWalletList,
  setClientWalletCharge: setClientWalletCharge,
  getExtendedClientWalletList: getExtendedClientWalletList,
  setClientWalletInitial: setClientWalletInitial,
};

